export enum ProvinceEnum {
  Quebec = 'QUEBEC',
  Ontario = 'ONTARIO',
  Alberta = 'ALBERTA',
  BritishColumbia = 'BRITISH_COLUMBIA',
  PrinceEdwardIsland = 'PRINCE_EDWARD_ISLAND',
  Manitoba = 'MANITOBA',
  NewBrunswick = 'NEW_BRUNSWICK',
  NovaScotia = 'NOVA_SCOTIA',
  Saskatchewan = 'SASKATCHEWAN',
  Newfoundland = 'NEWFOUNDLAND',
  Yukon = 'YUKON',
  Nunavut = 'NUNAVUT',

}
